/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Einvoice_Stuck_Refused_UnknownInputs */

const vi_einvoice_stuck_refused_unknown = /** @type {(inputs: Einvoice_Stuck_Refused_UnknownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`MISA từ chối hóa đơn này. Báo quản trị.`)
};

/**

* @param {Einvoice_Stuck_Refused_UnknownInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const einvoice_stuck_refused_unknown = /** @type {((inputs?: Einvoice_Stuck_Refused_UnknownInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Einvoice_Stuck_Refused_UnknownInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_einvoice_stuck_refused_unknown(inputs)
});